import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@material-ui/core'


export default function ExportDialog({ open = false, onClose = undefined as any, onChangeSubmitted = undefined as any }) {

	const [filename, setFilename] = useState("Export")

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Export mana graph</DialogTitle>
			<DialogContent>
				<Box display="flex" alignItems="center" gridGap="8px">
					<TextField
						placeholder="filename"
						variant="outlined"
						size="small"
						autoFocus
						value={filename}
						onChange={e => setFilename(e.target.value)}
					/>
					<Typography color="primary">.mg.json</Typography>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button
					variant="contained"
					color="primary"
					disableElevation

					onClick={() => {
						onChangeSubmitted(filename)
						onClose()
					}}
				>
					EXPORT
				</Button>
			</DialogActions>
		</Dialog>
	)
}
